<div>

    <div class="row">
        <div class="col-6">
            <button type="button" class="btn-back kite-btn-back" aria-label="Close" [routerLink]="['/dashboard']">
                <span class="mr-2">&#60;</span>Back
              </button>
        </div>
        <div class="col-md-6">
            <h3 class="float-right mr-3">OIL RECOVER MANAGEMENT</h3>
        </div>
    </div>

    <div class="row animated fadeIn mt-2">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body bg-white border" style="border-radius:15px!important">
                    <div class="row">
                        <div class="col-md-7">
                            <label class="label" for="oilRecoveryBusinessId">Business ID</label>
                            <input id="oilRecoveryBusinessId" #input class="form-control" [placeholder]="'Insert the Customer ID...'" style="background-color:#f3f7f9; border: none !important;">
                        </div>

                        <div class="col-md-5">
                            <button type="button" class="btn btn-themecolor btn-block kite-button" style="margin-top: 1.75rem; padding: .65rem;" (click)="filterByGui(input.value)">
                           Create New Oil Recovery
                        </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- ** Alerta de No hay Registros y Cargando Datos -->
    <div class="row mt-4 animated fadeIn" *ngIf="datos_arr_Tmp.length == 0">
        <div class="col">

            <div class="alert alert-info text-center" role="alert" *ngIf="message  !== 'No Data'">
                <strong>Loading</strong>
                <br>
                <i class="fa fa-spinner fa-spin fa-2x mt-2"></i>
                <br>
                <span class="mt-2">Please wait</span>
            </div>

            <div class="alert alert-warning text-center" role="alert" *ngIf="message == 'No Data'">
                <strong>{{message}}</strong>
                <br>
                <i class="fa fa-warning fa-2x"></i>
            </div>

        </div>
    </div>
    <!-- Wijmo. -->
    <div class="row">
        <div class="col-3">
            <app-custom-button
        [type]="'button'"
        style="background-color:#5bcc02; color: #fff;font-weight: 600; text-transform: uppercase;"
        [extraClasses]="
          'btn btn-default form-control d-inline-block btn-excel custom-btn btn-export-excel'
        "
        (buttonClick)="save()"
      >
        Export List
      </app-custom-button>
            <!-- <button (click)="save()" class="btn btn-default " style="background-color:#5bcc02; color: #fff;font-weight: 600; text-transform: uppercase;">
                         <i class="fa fa-file-excel text-success" style="color:#fff!important;"></i>
                          Export List
                        </button> -->
        </div>
    </div>
    <div class="row animated fadeIn mt-1">
        <div class="col-12">
            <div class="card p-0">
                <div class="card-body bg-white p-0">

                    <div class="row">
                        <div class="col">

                            <div class="grid-panel">

                                <!-- Tier 6: wj-flex-grid → app-kite-grid. The 3
                                     action buttons (info, delete, pdf) are now
                                     part of a single createActionColumn on the
                                     left. The legacy <wj-flex-grid-column> elements
                                     are replaced by createPlainColumn calls in the
                                     component's columnDefs. -->
                                <app-kite-grid
                                    [columnDefs]="columnDefs"
                                    [rowData]="pagination_arr"
                                    [totalRecords]="pagination_arr.length"
                                    [pageSize]="pagination_arr.length || 1"
                                    (cellClicked)="onCellClicked($event)">
                                </app-kite-grid>
                            </div>
                            <br>
                            <div class="total-records">
                              Total: <strong>{{ totalRecords }}</strong> Records
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!----MODALS-->
<wj-popup #editOilRecoveryModal>
    <div class="modal-header btn-themecolor dialog-title">
        <h4 class="modal-title text-white" id="modalLabel">UPDATED OIL RECOVERY</h4>
        <button type="button" class="btn-close wj-hide" aria-label="Close" tabindex="-1">
        </button>
    </div>
    <div class="kite-modal-body p-4">
        <form [formGroup]="oilRecoveryForm" autocomplete="off" ngNativeValidate>
            <div class="row">
                <div class="col-md-6">
                    <div class="mb-3">
                        <label for="name_oilrecovery" class="label">Restaurant name:</label>
                        <input type="text" class="form-control" id="name_oilrecovery" formControlName="name_oilrecovery" disabled toUppercase>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label for="city" class="label">City:</label>
                        <input type="text" class="form-control" id="city" formControlName="city" disabled toUppercase>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label for="address" class="label">Address:</label>
                        <input type="text" class="form-control" id="address" formControlName="address" disabled toUppercase>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label for="zip_code" class="label">Zip code:</label>
                        <input type="text" class="form-control" id="zip_code" formControlName="zip_code" disabled toUppercase>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-3">
                        <label for="citysel" class="label">County:</label>
                        <input type="text" class="form-control" id="citysel" formControlName="citysel" disabled toUppercase>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="mb-3">
                        <label for="date_registered" class="label">Date:</label>
                        <input type="date" class="form-control" id="date_registered" formControlName="date_registered">
                        <small *ngIf="(date_registered.invalid  && date_registered.touched) || (formSubmitted && date_registered.errors?.required)" class="text-danger animated fadeIn">* Date is required</small>
                    </div>
                </div>
                <div class="col-md-8">
                    <div class="mb-3">
                        <label for="gal_collected" class="label">Volume collected (gallons):</label>
                        <input type="number" class="form-control" id="gal_collected" formControlName="gal_collected" #t (blur)="calcularWaste(t.value)" placeholder="0">
                        <small *ngIf="(gal_collected.invalid  && gal_collected.touched) || (formSubmitted && gal_collected.errors?.required)" class="text-danger animated fadeIn">* Volume collected is required</small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label for="delivery_by" class="label">Delivery by:</label>
                        <input type="text" class="form-control" id="delivery_by" formControlName="delivery_by" toUppercase>
                        <small *ngIf="(delivery_by.invalid && delivery_by.touched) ||  (formSubmitted && delivery_by.errors?.required)" class="text-danger animated fadeIn">* Delivery by is required</small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label for="collected_by" class="label">Collected by:</label>
                        <input type="text" class="form-control" id="collected_by" formControlName="collected_by" toUppercase>
                        <small *ngIf="(collected_by.invalid && collected_by.touched) ||  (formSubmitted && collected_by.errors?.required)" class="text-danger animated fadeIn">* Collected by is required</small>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col text-center">
                    <button type="submit" class="btn btn-themecolor kite-button" (click)="updatedRegister(editOilRecoveryModal)">UPDATED OIL RECOVERY</button>
                </div>
            </div>
        </form>
    </div>
</wj-popup>
<!-- New CLIENT - Modal -->
<ng-template #newOilRecoveryModal let-modal>
    <div class="modal-header btn-themecolor dialog-title">
        <h4 class="modal-title text-white" id="modalLabel">CREATE NEW OIL RECOVERY</h4>
        <button type="button " class="btn-close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
        </button>
    </div>
    <div class="kite-modal-body p-4">
        <form [formGroup]="oilRecoveryForm" (ngSubmit)="newRegister(modal)" autocomplete="off" ngNativeValidate>
            <div class="row" style="border: 1px solid #08b9f2!important; padding:1%; border-radius: 15px; margin-bottom:3%">
                <div class="col-lg-2 col-md-4 col-xs-12">
                    <div class="mb-2">
                        <label for="ident_GUI" class="label">ID CUSTOMER</label>
                        <input type="text" class="form-control kite-id-form-control" id="ident_GUI" formControlName="ident_GUI" disabled toUppercase>
                    </div>
                </div>
                <div class="col-lg-10 col-md-8 col-xs-12">
                    <div class="mb-2">
                        <label for="name_oilrecovery" class="label">CLIENT NAME and ADDRESS</label>
                        <input type="text" class="form-control kite-form-control" id="name_oilrecovery" formControlName="name_oilrecovery" disabled toUppercase>
                    </div>
                </div>
                <!--<div class="col-md-6">
                  <div class="mb-2">
                      <label for="address" class="label">Address</label>
                      <input type="text" class="form-control" id="address" formControlName="address" disabled toUppercase>
                  </div>
              </div>-->
                <div class="col-md-5">
                    <div class="mb-2">
                        <label for="city" class="label">City</label>
                        <input type="text" class="form-control kite-form-control" id="city" formControlName="city" disabled toUppercase>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="mb-2">
                        <label for="citysel" class="label">County</label>
                        <input type="text" class="form-control kite-form-control" id="citysel" formControlName="citysel" disabled toUppercase>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="mb-2">
                        <label for="zip_code" class="label">Zip code</label>
                        <input type="text" class="form-control kite-form-control" id="zip_code" formControlName="zip_code" disabled toUppercase>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-xs-12">
                    <div class="mb-2">
                        <label for="date_registered" class="label">Date</label>
                        <input type="date" class="form-control" id="date_registered" formControlName="date_registered">
                        <small *ngIf="(date_registered.invalid  && date_registered.touched) || (formSubmitted && date_registered.errors?.required)" class="text-danger animated fadeIn">* Date is required</small>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-xs-12">
                    <div class="mb-3">
                        <label for="gal_collected" class="label">gallons collected</label>
                        <input type="number" class="form-control" id="gal_collected" formControlName="gal_collected" #t (blur)="calcularWaste(t.value)" placeholder="0">
                        <small *ngIf="(gal_collected.invalid  && gal_collected.touched) || (formSubmitted && gal_collected.errors?.required)" class="text-danger animated fadeIn">* Volume collected is required</small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label for="delivery_by" class="label">Delivery by:</label>
                        <input type="text" class="form-control" id="delivery_by" formControlName="delivery_by" toUppercase>
                        <small *ngIf="(delivery_by.invalid && delivery_by.touched) ||  (formSubmitted && delivery_by.errors?.required)" class="text-danger animated fadeIn">* Delivery by is required</small>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="mb-3">
                        <label for="collected_by" class="label">Collected by:</label>
                        <input type="text" class="form-control" id="collected_by" formControlName="collected_by" toUppercase>
                        <small *ngIf="(collected_by.invalid && collected_by.touched) ||  (formSubmitted && collected_by.errors?.required)" class="text-danger animated fadeIn">* Collected by is required</small>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col text-center">
                    <button *ngIf="titulo" type="submit" class="btn btn-themecolor kite-button">NEW OIL RECOVERY</button>
                    <button *ngIf="!titulo" type="submit" class="btn btn-themecolor kite-button">UPDATED OIL RECOVERY</button>

                </div>
            </div>
        </form>
    </div>
</ng-template>

<!-- MODAL DELETE -->
<ng-template #deleteModal let-modal>
    <div class="modal-header btn-themecolor dialog-title">
        <h4 class="modal-title text-white" id=" modalLabel">DELETE OIL RECOVERY</h4>
        <button type="button " class="btn-close " aria-label="Close " (click)="modal.dismiss( 'Cross click') ">
        </button>
    </div>
    <div class="modal-body">
        <div style="border-bottom: 1px solid #1CB9F2; padding:15px ; text-align: center">
            <h2 class="mr-2 kite-delete-label">Do you want to Delete the <strong>{{oilRecovery.client.name_client | uppercase}} </strong> Located at <strong>{{oilRecovery.client.address | uppercase}} of {{oilRecovery.client.city}}</strong> City?</h2>
        </div>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col text-center">
                <button type="button" class="btn kite-btn-close" data-dismiss="modal" (click)="modal.dismiss('close')">Close</button>
            </div>
            <div class="col text-center">
                <button type="button" class="btn kite-button-cancel" (click)="deleteOilRecovery(modal, oilRecovery)">Yes, Delete it!</button>
            </div>
        </div>

    </div>

</ng-template>
<!-- MODAL INFO -->
<ng-template #infoModal let-modal>
    <div>
        <div class="modal-header" style="background-color:var(--color-brand-main, #2e5ea8);">
            <h4 class="modal-title text-white " id=" modalInfotitle ">CUSTOMER INFORMATION</h4>
        </div>
        <div class="modal-body" style="margin:3%!important">
            <div class="row kite-border-info">
                <div class="row" style="align-self:center">
                    <div class="col-6" style="align-self:center">
                        <h4>{{oilRecovery.client.name_client | uppercase}}</h4>
                    </div>
                    <div class="col" style="align-self:center">
                        <h4 class="label">CREATED</h4>
                    </div>
                    <div class="col" style="align-self:center;background-color: #ececec; border-radius: 15px; text-align: center;">
                        <h5 style="padding: 3px;text-align: center!important;">{{oilRecovery.month}}/{{oilRecovery.day}}/{{oilRecovery.year}}</h5>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-bottom:1%;">
                <div class="col-2 kite-title-info">Contact Name:</div>
                <div class="col-md kite-label-info">{{oilRecovery.client.contact_name | titlecase}}</div>
                <div class="col-2 kite-title-info">Phone Number:</div>
                <div class="col-md kite-label-info">{{oilRecovery.client.phone | titlecase}}</div>
            </div>
            <div class="row" style="margin-bottom:1%;">
                <div class="col-2 kite-title-info">Email Address:</div>
                <div class="col-md kite-label-info">{{oilRecovery.client.email | titlecase}}</div>
                <div class="col-2 kite-title-info">Address:</div>
                <div class="col-lg kite-label-info">{{oilRecovery.client.address}}</div>
            </div>
            <div class="row" style="margin-bottom:1%;">
                <div class="col-2 kite-title-info">City:</div>
                <div class="col-md kite-label-info">{{oilRecovery.client.city | titlecase}}</div>
                <div class="col-2 kite-title-info">Sales Person:</div>
                <div class="col-md kite-label-info">{{oilRecovery.client.sales_person | titlecase}}</div>
            </div>
            <div class="row" style="margin-bottom:1%;">

            </div>
            <div class="modal-footer" style="border-top: 1px solid #ececec; justify-content:center!important">
                <div class="col text-center">
                    <button type="button" class="btn kite-btn-close" data-dismiss="modal" (click)="modal.dismiss('close')">Close</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
